<div class="[ stack stack-space-m center-items content-center ] [ max-w-xl ]">
  @if (icon) {
    <campus-icon [svgIcon]="icon" class="[ secundary ]"></campus-icon>
  }
  <p class="[ on-surface text-center headline-small ]">{{ title }}</p>

  @if (message) {
    <div class="[ overflow-auto max-h-2xs ]">
      <campus-froala-viewer class="[ on-surface body-medium ]" [content]="message"></campus-froala-viewer>
    </div>
  }

  <div class="[ flex gap-s flex-row justify-self-end ]">
    @if (cancelButtonLabel) {
      <button campusClickStopPropagation inline-button (click)="cancel()">
        {{ cancelButtonLabel }}
      </button>
    }

    @if (confirmButtonLabel) {
      <button
        campusClickStopPropagation
        filled-button
        (click)="confirm()"
        [class.error]="confirmButtonType === 'danger'"
        >
        {{ confirmButtonLabel }}
      </button>
    }
  </div>
</div>
